import ConditionalToolTip from "components/design/conditionalToolTip";
import { Button } from "components/DesignSystem/Button/Button";
import { PadlockIcon } from "components/icons/PadlockIcon";
import { ReactNode } from "react";

type ResyncInvoiceButtonProps = {
  // Why the invoice can't be resynced; disables the button and shows on hover
  blocker?: ReactNode;
  isLoading?: boolean;
  onClick: () => void;
};

// Sits at the right edge of banners and tables, so the tooltip opens leftwards and stays on screen
export const ResyncInvoiceButton = ({
  blocker,
  isLoading = false,
  onClick,
}: ResyncInvoiceButtonProps) => (
  <ConditionalToolTip
    condition={blocker}
    side="bottom"
    align="end"
    sideOffset={16}
    collisionPadding={16}
  >
    <span className="t-inline-flex">
      <Button
        type="button"
        size="small"
        onClick={onClick}
        isLoading={isLoading}
        disabled={Boolean(blocker) || isLoading}
      >
        <span className="t-flex t-items-center t-gap-1.5">
          {blocker && (
            <span aria-hidden="true" className="t-flex">
              <PadlockIcon />
            </span>
          )}
          Re-sync invoice
        </span>
      </Button>
    </span>
  </ConditionalToolTip>
);
